import format from '../../utility/format';
import validate from '../../utility/validate.js';

import ErrorList from '../../components/ErrorList';

export default class RemainderAnnuityTrustParams {

    type = 'fixed'
    trustType = 'variable'
    age1 = 75
    age2 = 75
    years = 5
    giftAmount = 500000
    payoutRate = 0.05
    method = 'interpolate'
    paymentSchedule = 'quarterly'

    validate(clientDefaults) {
      var errors = new ErrorList();

      var defaultsId = 'crut';
      if (this.trustType === 'fixed') {
        defaultsId = 'crat';
      }

      var type = this.type;
      if (type === 'fixed') {
          errors.set('years', validate.number(this.years, {
              min: clientDefaults[defaultsId + 'MinimumFixedPeriod'],
              max: clientDefaults[defaultsId + 'MaximumFixedPeriod'],
          })); 
      }
      if (type === 'single' || type === 'double') {
          errors.set('age1', validate.number(this.age1, {
              min: clientDefaults[defaultsId + 'MinimumAge'],
              max: clientDefaults[defaultsId + 'MaximumAge'],
          }));
      }
      if (type === 'double') {
          errors.set('age2', validate.number(this.age2, {
              min: clientDefaults[defaultsId + 'MinimumAge'],
              max: clientDefaults[defaultsId + 'MaximumAge'],
          }));
      }

      errors.set('giftAmount', validate.number(this.giftAmount, {
          min: clientDefaults[defaultsId + 'MinimumGift'],
          max: clientDefaults[defaultsId + 'MaximumGift'],
          formatter: format.dollars,
      }));

      errors.set('payoutRate', validate.number(this.payoutRate, {
          min: clientDefaults[defaultsId + 'MinimumPayoutRate'],
          max: clientDefaults[defaultsId + 'MaximumPayoutRate'],
          formatter: format.percent,
      }));

      return errors;
    }

    toRequest() {
        var request = {};

        request.trustType = this.trustType;
        request.giftAmount = this.giftAmount;
        request.payoutRate = this.payoutRate;
        request.method = this.method;
        request.paymentSchedule = this.paymentSchedule;

        var type = this.type;
        if (type === 'double') {
            request.age1 = this.age1;
            request.age2 = this.age2;
        } else if (type === 'single') {
            request.age1 = this.age1;
        } else {
            request.years = this.years;
        }

        return request;
    }

    clone() {
        var clone = new RemainderAnnuityTrustParams();
        clone = Object.assign(clone, this);
        return clone;
    }

}

RemainderAnnuityTrustParams.fromClientDefaults = function(clientDefaults) {
  var params = new RemainderAnnuityTrustParams();

  params.type = 'fixed';
  params.method = 'interpolate';
  params.age1 = clientDefaults.cratDefAge;
  params.age2 = clientDefaults.cratDefAge;
  params.years = clientDefaults.cratDefFixedPeriod;
  params.giftAmount = clientDefaults.cratDefGift;
  params.payoutRate = clientDefaults.cratDefPayoutRate;
  params.paymentSchedule = clientDefaults.cratPaymentSchedule;

  return params;
};
